import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    recordList: {
      requesting: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      error: null,
      success: false,
      filters: {},
    },
    details: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    condition: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    lineage: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    inventoryList: {
      requesting: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      error: null,
      success: false,
      filters: {},
    },
    inventoryDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    photoList: {
      requesting: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      error: null,
      success: false,
      filters: {},
    },
    transferList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
  };

export const farmAnimalSlice = createSlice({
  name: 'farmAnimal',
  initialState,
  reducers: {
    getFarmAnimalList: (state, action) => {		
      state.recordList.requesting = true;
      state.recordList.error = null;
      state.recordList.items = [];
      state.recordList.success = false;
      state.recordList.filters = action.payload;
    },
    getFarmAnimalListSuccess: (state, action) => {
		  const { data, current_page, per_page, total} = action.payload;
      state.recordList.requesting = false;        
      state.recordList.items = data;
      state.recordList.success = true; 
      state.recordList.pagination.current_page = current_page;
      state.recordList.pagination.per_page = per_page;
      state.recordList.pagination.total = total;
    },
    getFarmAnimalListFail: (state, action) => {        
      state.recordList.requesting = false;
      state.recordList.error = action.payload;
    },
    getFarmAnimalDetails: (state) => {
      state.details.requesting = true;
      state.details.error = null;
      state.details.data = null;
      state.details.success = false; 
    },
    getFarmAnimalDetailsSuccess: (state, action) => {
      state.details.requesting = false;
      state.details.data = action.payload;
      state.details.success = true; 
    },
    getFarmAnimalDetailsFail: (state, action) => {        
      state.details.requesting = false;
      state.details.error = action.payload;
    },
    doFarmAnimalCreate: (state) => {
      state.details.requesting = true;
      state.details.error = null;
      state.details.data = null;
      state.details.success = false; 
    },
    doFarmAnimalUpdate: (state) => {
      state.details.requesting = true;
      state.details.error = null;
      state.details.data = null;
      state.details.success = false; 
    },
    doFarmAnimalDelete: (state) => {
      state.details.requesting = true;
      state.details.error = null;
      state.details.data = null;
      state.details.success = false; 
    },
    getAnimalInventoryList: (state, action) => {		
      state.inventoryList.requesting = true;
      state.inventoryList.error = null;
      state.inventoryList.items = [];
      state.inventoryList.success = false;
      state.inventoryList.filters = action.payload;
    },
    getAnimalInventoryListSuccess: (state, action) => {
		  const { data, current_page, per_page, total} = action.payload;
      state.inventoryList.requesting = false;        
      state.inventoryList.items = data;
      state.inventoryList.success = true; 
      state.inventoryList.pagination.current_page = current_page;
      state.inventoryList.pagination.per_page = per_page;
      state.inventoryList.pagination.total = total;
    },
    getAnimalInventoryListFail: (state, action) => {        
      state.inventoryList.requesting = false;
      state.inventoryList.error = action.payload;
    },
    getAnimalInventoryDetails: (state) => {
      state.inventoryDetails.requesting = true;
      state.inventoryDetails.error = null;
      state.inventoryDetails.data = null;
      state.inventoryDetails.success = false; 
    },
    getAnimalInventoryDetailsSuccess: (state, action) => {
      state.inventoryDetails.requesting = false;
      state.inventoryDetails.data = action.payload;
      state.inventoryDetails.success = true; 
    },
    getAnimalInventoryDetailsFail: (state, action) => {        
      state.inventoryDetails.requesting = false;
      state.inventoryDetails.error = action.payload;
    },
    doAnimalInventoryCreate: (state) => {
      state.inventoryDetails.requesting = true;
      state.inventoryDetails.error = null;
      state.inventoryDetails.data = null;
      state.inventoryDetails.success = false; 
    },
    doAnimalInventoryUpdate: (state) => {
      state.inventoryDetails.requesting = true;
      state.inventoryDetails.error = null;
      state.inventoryDetails.data = null;
      state.inventoryDetails.success = false; 
    },
    doAnimalInventoryDelete: (state) => {
      state.inventoryDetails.requesting = true;
      state.inventoryDetails.error = null;
      state.inventoryDetails.data = null;
      state.inventoryDetails.success = false; 
    },

    getAnimalPhotoList: (state, action) => {		
      state.photoList.requesting = true;
      state.photoList.error = null;
      state.photoList.items = [];
      state.photoList.success = false;
      state.photoList.filters = action.payload;
    },
    getAnimalPhotoListSuccess: (state, action) => {
		  const { data, current_page, per_page, total} = action.payload;
      state.photoList.requesting = false;        
      state.photoList.items = data;
      state.photoList.success = true; 
      state.photoList.pagination.current_page = current_page;
      state.photoList.pagination.per_page = per_page;
      state.photoList.pagination.total = total;
    },
    getAnimalPhotoListFail: (state, action) => {        
      state.photoList.requesting = false;
      state.photoList.error = action.payload;
    },

    doUploadAnimalPhoto: (state) => {
      state.photoList.requesting = true;
      state.photoList.error = null;
      state.photoList.success = false; 
    },
    doUploadAnimalPhotoSuccess: (state, action) => {
      state.photoList.requesting = false;
      state.photoList.success = true; 
    },
    doUploadAnimalPhotoFail: (state, action) => {        
      state.photoList.requesting = false;
      state.photoList.error = action.payload;
    },

    doInventoryTransferUpdate: (state) => {
      state.condition.requesting = true;
      state.condition.error = null;
      state.condition.data = null;
      state.condition.success = false; 
    },
    doInventoryTransferUpdateSuccess: (state, action) => {
      const updatedItem = action.payload;
      state.condition.requesting = false;
      state.condition.data = updatedItem;
      state.condition.success = true;
      state.recordList.items = state.recordList.items.map(item =>
        item.id === updatedItem.id ? { ...item, ...updatedItem } : item
      );
    },
    doInventoryTransferUpdateFail: (state, action) => {        
      state.condition.requesting = false;
      state.condition.error = action.payload;
    },

    getAnimalLineageDetails: (state) => {
      state.lineage.requesting = true;
      state.lineage.error = null;
      state.lineage.data = null;
      state.lineage.success = false; 
    },
    getAnimalLineageDetailsSuccess: (state, action) => {
      state.lineage.requesting = false;
      state.lineage.data = action.payload;
      state.lineage.success = true; 
    },
    getAnimalLineageDetailsFail: (state, action) => {        
      state.lineage.requesting = false;
      state.lineage.error = action.payload;
    },

    getAnimalTransferList: (state, action) => {		
      state.transferList.requesting = true;
      state.transferList.error = null;
      state.transferList.items = [];
      state.transferList.success = false;
      state.transferList.filters = action.payload;
    },
    getAnimalTransferListSuccess: (state, action) => {
      state.transferList.requesting = false;        
      state.transferList.items = action.payload;
      state.transferList.success = true; 
    },
    getAnimalTransferListFail: (state, action) => {        
      state.transferList.requesting = false;
      state.transferList.error = action.payload;
    },

  },
})

export const { 
    getFarmAnimalList, getFarmAnimalListSuccess, getFarmAnimalListFail,
    getFarmAnimalDetails, getFarmAnimalDetailsSuccess, getFarmAnimalDetailsFail,
    doFarmAnimalCreate, doFarmAnimalUpdate, doFarmAnimalDelete,
    getAnimalInventoryList, getAnimalInventoryListSuccess, getAnimalInventoryListFail,
    getAnimalInventoryDetails, getAnimalInventoryDetailsSuccess, getAnimalInventoryDetailsFail,
    doAnimalInventoryCreate, doAnimalInventoryUpdate, doAnimalInventoryDelete,
    getAnimalPhotoList, getAnimalPhotoListSuccess, getAnimalPhotoListFail,
    doUploadAnimalPhoto, doUploadAnimalPhotoSuccess, doUploadAnimalPhotoFail,
    doInventoryTransferUpdate, doInventoryTransferUpdateSuccess, doInventoryTransferUpdateFail,
    getAnimalLineageDetails, getAnimalLineageDetailsSuccess, getAnimalLineageDetailsFail,
    getAnimalTransferList, getAnimalTransferListSuccess, getAnimalTransferListFail,
} = farmAnimalSlice.actions

export default farmAnimalSlice.reducer